module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errorTitle":"Error","errorMessage":"Can\u0027t open url"},"ru":{"errorTitle":"Ошибка","errorMessage":"Не удалось открыть ссылку"}}')
  delete Component.options._Ctor
}
